<script setup lang="ts">
import MiniArtifactDisplay from '@/components/artifacts/MiniArtifactDisplay.vue'
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import CustomNodeEditMenu from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'

const props = defineProps(nodeViewProps)

const artifactId = props.node.attrs.artifactId
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-inline-block align-items-center justify-content-center"
  >
    <CustomNodeEditMenu
      :selected="props.selected"
      :editor-focused="props.editor.isFocused"
      :variant-parameters="node.attrs"
      current-variant="artifact-card"
      :variants="[
        { tag: 'inline-artifact', label: 'Inline', icon: 'mdi-text' },
        { tag: 'artifact-card', label: 'Card', icon: 'mdi-card-text' },
      ]"
      :node-props="props"
    >
      <template #element="nodeProps">
        <MiniArtifactDisplay
          :artifact-id="artifactId"
          v-bind="nodeProps"
        />
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
